var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompartir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.27 39.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.45,30.28c0,4.96-4.04,9-9,9h-11.45c-4.96,0-9-4.04-9-9v-11.45c0-4.96,4.04-9,9-9,1.36,0,2.45,1.1,2.45,2.45s-1.1,2.45-2.45,2.45c-2.26,0-4.09,1.83-4.09,4.09v11.45c0,2.26,1.83,4.09,4.09,4.09h11.45c2.26,0,4.09-1.83,4.09-4.09,0-1.36,1.1-2.45,2.45-2.45s2.45,1.1,2.45,2.45Zm8.18-22.01L30.4.76c-.95-.98-2.49-1.01-3.47-.07-.98.95-1.01,2.49-.07,3.47l5.45,5.66h-10.23c-4.96,0-9,4.04-9,9v8.18c0,1.36,1.1,2.45,2.45,2.45s2.45-1.1,2.45-2.45v-8.18c0-2.26,1.83-4.09,4.09-4.09h10.23l-5.45,5.66c-.93.98-.92,2.54.07,3.47.47.46,1.1.69,1.7.69.64,0,1.29-.25,1.77-.75l7.18-7.46c2.24-2.23,2.24-5.87.03-8.07h.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompartir);
export default __webpack_public_path__ + "static/media/COMPARTIR.fb3d49b806946f729525470f7a52388c.svg";
export { ForwardRef as ReactComponent };